import { memoize } from "@plansoft-configuration-renderer/utils";
import { tryCreateNumberFormat } from "./tryCreateNumberFormat";
/**
 * Creates a formatting function for prices with currency
 * @param options
 * @returns
 */
export function createPriceFormatter(options) {
    const numberFormat = tryCreateNumberFormat(options.localeCode, {
        style: "currency",
        currency: "EUR",
    });
    return (value) => {
        const formatted = numberFormat.format(value);
        // replace € symbol with currency symbol from currency info
        return formatted.replace("€", options.currencyInfo.symbol);
    };
}
/**
 * Memoized version of {@link createPriceFormatter}
 */
export const createPriceFormatterMemoized = memoize(createPriceFormatter);
//# sourceMappingURL=createPriceFormatter.js.map